import i18n from 'i18next';

function setLanguage(market_id, props) {
  const { i18n } = props;

  if (market_id === "5d6cbf70-eb0d-4287-acd0-3226ee6fc9e0") {
    i18n.changeLanguage("en-AU");
  } else if (market_id === "931b3d0f-011e-4f44-9af0-5a08f8af3f00") {
    i18n.changeLanguage("fr");
  } else if (market_id === "d4f88102-630c-4ea5-9fb3-cab6ed6e9f49") {
    i18n.changeLanguage("es");
  } else if (market_id === "63c34b5b-1730-4401-9c4a-e2a9b49426b6") {
    i18n.changeLanguage("it");
  } else if (market_id === "ca045dbe-0de7-45f3-920b-e5bb6bd6168e") {
    i18n.changeLanguage("de");
  } else if (market_id === "8fd4b173-f063-45d9-98c3-fd899ca0e4ba") {
    i18n.changeLanguage("en");
  } else if (market_id === "f107c141-cf1a-4f1c-b5d8-710b5e16ef05") {
      i18n.changeLanguage("en-ca");
  } else if (market_id === "09343b5b-deb4-4b3c-8f6b-6164f4447d4c") {
    i18n.changeLanguage("es-MX");
  } else {
    i18n.changeLanguage("en");
  }
}

export const getLanguage = () => {
    return i18n.language ||
        (typeof window !== 'undefined' && window.localStorage.i18nextLng) ||
        'en';
};

function isFranceMarket(market_id) {
    return market_id === "931b3d0f-011e-4f44-9af0-5a08f8af3f00" ? true : false;
}

function isGermanMarket(market_id) {
    return market_id === "ca045dbe-0de7-45f3-920b-e5bb6bd6168e" ? true : false;
}

function isSpainMarket(market_id) {
    return market_id === "d4f88102-630c-4ea5-9fb3-cab6ed6e9f49" ? true : false;
}

function isItalyMarket(market_id) {
    return market_id === "63c34b5b-1730-4401-9c4a-e2a9b49426b6" ? true : false;
}

function isUkMarket(market_id) {
    return market_id === "8fd4b173-f063-45d9-98c3-fd899ca0e4ba" ? true : false;
}

export default {
    setLanguage,
    getLanguage,
    isFranceMarket,
    isGermanMarket,
    isSpainMarket,
    isItalyMarket,
    isUkMarket
}